import { BreadCrumbItem } from "@containers/Layout/PageHeader/headerFactory";
import { getBaseUrl } from "@utils/urlResolver";

export function getBreadcrumbsMarkup(breadcrumbs: BreadCrumbItem[]) {
  if ((breadcrumbs?.length ?? 0) < 2) return null;

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: breadcrumb.name,
      item: getBaseUrl() + breadcrumb.url,
    })),
  };
}
